import { render, staticRenderFns } from "./SurnameResearchComponent.vue?vue&type=template&id=90b3b40c&scoped=true&"
import script from "./SurnameResearchComponent.vue?vue&type=script&lang=js&"
export * from "./SurnameResearchComponent.vue?vue&type=script&lang=js&"
import style0 from "./SurnameResearchComponent.vue?vue&type=style&index=0&id=90b3b40c&prod&lang=scss&"
import style1 from "./SurnameResearchComponent.vue?vue&type=style&index=1&id=90b3b40c&prod&scoped=true&lang=scss&"
import style2 from "./SurnameResearchComponent.vue?vue&type=style&index=2&id=90b3b40c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b3b40c",
  null
  
)

export default component.exports